import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { type ClientAuthenticatedUserWithSelectedRole } from '@/src/auth';

interface UseInitializeDatadogUserParams {
  readonly user: ClientAuthenticatedUserWithSelectedRole | null;
}

export const useInitializeDatadogUser = ({ user }: UseInitializeDatadogUserParams) => {
  useEffect(() => {
    if (user?.selectedOrganizationRole && process.env.NODE_ENV === 'production') {
      const selectedRole = user.selectedOrganizationRole;
      datadogRum.setUser({
        email: user.email,
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        organization: selectedRole.organization.name,
        role: selectedRole.role,
      });
    }
  }, [user]);
};
